export const phoneSelect: any = [
  { key: 1, text: '010' },
  { key: 2, text: '016' },
  { key: 3, text: '017' },
  { key: 4, text: '019' },
  { key: 5, text: '011' },
]

export const locationSelect: any = [
  { key: '', text: '전체' },
  { key: '판타지월드', text: '판타지월드' },
  { key: '매직월드', text: '매직월드' },
  { key: '어드벤처월드', text: '어드벤처월드' },
  { key: '다이나믹월드', text: '다이나믹월드' },
  { key: '83타워', text: '83타워' },
]

export const heightSelect: any = [
  { key: '', text: '전체 이용가능' },
  { key: '90cm 이상' , text: '90cm 이상' },
  { key: '100cm 이상', text: '100cm 이상' },
  { key: '110cm 이상', text: '110cm 이상' },
  { key: '120cm 이상', text: '120cm 이상' },
  { key: '140cm 이상', text: '140cm 이상' },
  { key: '90cm~130cm', text: '90cm~130cm' },
  { key: '90cm~100cm(보호자동승시)', text: '90cm~100cm(보호자동승시)' },
]

export const termsSelect: any = [
  { key: 1, text: '전체' },
  { key: 2, text: '어린이 전용' },
  { key: 3, text: '65세 이하 탑승 가능' },
]

export const noticeSelect: any = [{ key: 1, text: '공지' }]

export const questionSelect: any = [
  { key: 1, text: '이월드 이용문의' },
  { key: 2, text: '홈페이지 이용문의' },
  { key: 3, text:'결제관련 이용문의' },
  { key: 4, text: '연간회원 문의' },
  { key: 5, text: '불만사항' },
  { key: 6, text: '건의합니다.' },
  { key: 7, text: '칭찬합니다.' },
  { key: 8, text: '기타' },
]

export const faqSelect: any = [
  { key: 1, text: '전체' },
  { key: 2, text: '이용안내' },
  { key: 3, text: '단체문의' },
  { key: 4, text: '연간회원' },
  { key: 5, text: '사이트이용' },
  { key: 6, text: '알파카목장이용' },
  { key: 7, text: '기타' },
]

export const towerNoticeSelect: any = [
  { key: 1, text: '공지' },
  { key: 2, text: '행사이벤트' },
  { key: 3, text: '운영시간 안내' },
]

export const towerFaqSelect: any = [
  { key: '', text: '전체' },
  { key: '이용안내', text: '이용안내' },
  { key: '교통', text: '교통' },
  { key: '서비스/시설', text: '서비스/시설' },
  { key: '할인상품권', text: '할인상품권' },
  { key: '이용권구매', text: '이용권구매' },
  { key: '기타', text: '기타' },
]

export const yearlyNewsSelect: any = [
  { key: 1, text: '전체' },
  { key: 2, text: '요금' },
  { key: 3, text: '혜택' },
  { key: 4, text: '이벤트' },
  { key: 5, text: '이용안내' },
  { key: 6, text: '기타' },
]

export const emailSelect: any[] = [
  { key: 'naver.com', text: '네이버' },
  { key: 'hanmail.net', text: '다음' },
  { key: 'gmail.com', text: '구글' },
  { key: 'nate.com', text: '네이트' },
  { key: '', text: '직접입력' },
]

export const languageSelect: any[] = [
  { key: 1, text: '영어' },
  { key: 2, text: '일본어' },
  { key: 3, text: '중국어' },
  { key: 4, text: '독일어' },
  { key: 5, text: '불어' },
  { key: 6, text: '스페인어' },
  { key: 7, text: '러시아어' },
  { key: 8, text: '이탈리아어' },
  { key: 9, text: '기타' },
]

export const languageLevelSelect: any[] = [
  { key: 1, text: '(상)의사소통가능' },
  { key: 2, text: '(중)기본회화 및 일반설명가능' },
  { key: 3, text: '(하)기본회화만 가능' },
]

export const cardSelect: any[] = [
  { key: 1, text: '비씨카드' },
  { key: 2, text: 'KB카드' },
  { key: 3, text: '하나카드' },
  { key: 4, text: '현대카드' },
  { key: 5, text: 'NH농협카드' },
  { key: 6, text: '삼성카드' },
]

export const menuSelect: any[] = [
  { key: '', text: '전체' },
  { key: '한식', text: '한식' },
  { key: '양식', text: '양식' },
  { key: '중식', text: '중식' },
  { key: '분식', text: '분식' },
  { key: '카페', text: '카페' },
  { key: '패스트푸트', text: '패스트푸트' },
  { key: '편의점', text: '편의점' },
  { key: '아이스크림', text: '아이스크림' },
  { key: '베이커리', text: '베이커리' },
  { key: '퓨전', text: '퓨전' },
]

export const recommenderSelect: any[] = [
  { key: 1, text: '정규직' },
  { key: 2, text: '계약직' },
  { key: 3, text: '아르바이트' },
  { key: 4, text: '인턴직' },
  { key: 5, text: '파트' },
  { key: 6, text: '기타' },
]

export const graduatedSelect: any[] = [
  { key: 1, text: '졸업' },
  { key: 2, text: '재학' },
  { key: 3, text: '수료' },
  { key: 4, text: '검정고시' },
  { key: 5, text: '중퇴' },
  { key: 6, text: '기타' },
  { key: 7, text: '휴학' },
]

export const educationSelect: any[] = [
  { key: 1, text: '고등학교 졸업 이상' },
  { key: 2, text: '대학 졸업(2~3년) 이상' },
  { key: 3, text: '대학교 졸업(4년) 이상' },
  { key: 4, text: '석사 졸업 이상' },
  { key: 5, text: '학력무관' },
]

export const applicantSelect: any[] = [
  { key: '어트랙션(놀이기구)', text: '어트랙션(놀이기구)' },
  { key: '눈썰매장', text: '눈썰매장' },
  { key: '단기알바', text: '단기알바' },
  { key: '동물농장', text: '동물농장' },
  { key: '디자인팀', text: '디자인팀' },
  { key: '매표/수표', text: '매표/수표' },
  { key: '상품판매', text: '상품판매' },
  { key: '식당보조(보건증 소지자)', text: '식당보조(보건증 소지자)' },
  { key: '식음판매(보건증 소지자)', text: '식음판매(보건증 소지자)' },
  { key: '안내데스크' , text: '안내데스크' },
  { key: '주차(매표, 관리 등)', text: '주차(매표, 관리 등)' },
  { key: '카페 바리스타', text: '카페 바리스타' },
  { key: '홈메이트(78층 전망대 레스토랑)', text: '홈메이트(78층 전망대 레스토랑)' },
]

export const allianceSelect: any[] = [
  { key: 1, text: '제휴문의' },
  { key: 2, text: '식음 입점문의' },
  { key: 3, text: '상품 입점문의' },
  { key: 4, text: '기타' },
]
